import { useEffect, createContext, useState } from 'react'
import { getAuth, getAuthGeneration, getConfig } from '../lib/allauth'
import { invalidateAccountData } from '../carbon/carbonApi'

export const AuthContext = createContext(null)

function Loading () {
  return <div>Starting...</div>
}

function LoadingError () {
  return <div>Loading error!</div>
}

export function AuthContextProvider (props) {
  const [auth, setAuth] = useState(undefined)
  const [config, setConfig] = useState(undefined)

  useEffect(() => {
    let active = true
    let eventGeneration = 0
    invalidateAccountData()
    function onAuthChanged (e) {
      eventGeneration += 1
      setAuth(auth => {
        if (typeof auth === 'undefined') {
          console.log('Authentication status loaded')
        } else {
          console.log('Authentication status updated')
        }
        return e.detail
      }
      )
    }

    document.addEventListener('allauth.auth.change', onAuthChanged)
    const authRequest = getAuth()
    const requestGeneration = getAuthGeneration()
    const initialEventGeneration = eventGeneration
    const isCurrent = () => active && eventGeneration === initialEventGeneration && getAuthGeneration() === requestGeneration
    authRequest.then(data => {
      if (isCurrent()) setAuth(data)
    }).catch((e) => {
      if (isCurrent()) {
        console.error(e)
        setAuth(false)
      }
    })
    getConfig().then(data => {
      if (active) setConfig(data)
    }).catch((e) => {
      if (active) console.error(e)
    })
    return () => {
      active = false
      document.removeEventListener('allauth.auth.change', onAuthChanged)
    }
  }, [])
  const loading = (typeof auth === 'undefined') || config?.status !== 200
  return (
    <AuthContext.Provider value={{ auth, config }}>
      {loading
        ? <Loading />
        : (auth === false
            ? <LoadingError />
            : props.children)}
    </AuthContext.Provider>
  )
}
